import { useEffect } from 'react'

interface useInitCentersProps {
  getRows: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
  unlockAccount: Function
  currentCustomer?: {} | null
}

const useInit = (props: useInitCentersProps) => {
  useEffect(() => {
    props
      .getRows({
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal,
        unlockAccount: props.unlockAccount,
      })
      .then((data: any) => {
        props.setRows(data)
        props.setShowOverlay(false)
      })
  }, [props.currentCustomer])
}

export default useInit
